export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/LB-6fa6cab5d92a521aab3e897b88c91e38.png";